import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe5dffb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_2 = ["data-cy", "onClick"]
const _hoisted_3 = { class: "mt-8 lg:block hidden" }

import AButton from "@/components/Base/AButton";
import ProgressIndicator from "@/components/ProgressIndicator";
import useScreenSize from "@/composables/useScreenSize";
import { useStore } from "@/composables/useTypedStore";
import Bestandsaufnahme from "@/models/ba/Bestandsaufnahme";
import { Fragenblock } from "@/models/ba/Fragenblock";
import { IonIcon, IonLabel, IonSegment, IonSegmentButton } from "@ionic/vue";
import { mapOutline, arrowDownCircleOutline } from "ionicons/icons";
import { computed, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BaTabs',
  props: {
  selectedView: {
    type: String,
    default: undefined
  },
  showMapButton: {
    type: Boolean,
    default: true
  }
},
  emits: ['showSummary', 'goTo', 'changeTab', 'showMap'],
  setup(__props, { emit }) {





const store = useStore();
const { isMinLarge } = useScreenSize();

let currentTab = '';

const ba = computed<Bestandsaufnahme | undefined>(() => {
  return store.state.currentHzba.currentBa;
});

const tabs = computed<Fragenblock[] | undefined>(() => {
  //@ts-ignore
  return ba.value?.fragenblocks?.filter(item => !item.config.isMapParent);
});

watch([tabs], (newVal) => {
  tabs.value?.forEach(el => el.setupUnlockDetector());
}, { immediate: true });

const changeRoute = (e: any) => {
  // Monitoring.consoleOnly("change route", e.detail.value)
  if (currentTab !== e.detail.value && e.detail.value) {
    currentTab = e.detail.value;
    // router.replace(`/ba/${ba.value!.id}/${e.detail.value}`)

    emit('changeTab', e.detail.value);
    // ionRouter.navigate(`/ba/${ba.value!.id}/${e.detail.value}`, 'root', 'replace', undefined);
  }
};

const changeRouteDesktop = (tab: Fragenblock) => {
  // router.replace(`/ba/${ba.value!.id}/${tab.identifier}`)
  // ionRouter.navigate(`/ba/${ba.value!.id}/${tab.identifier}`, 'root', 'replace', undefined);

  emit('changeTab', tab.identifier);
};

const downloadGeodata = () => {
  store.dispatch("currentHzba/downloadGeodata");
};

const goToSummary = () => {
  emit('showSummary');
};
const showMap = () => {
  emit('showMap');
}



return (_ctx: any,_cache: any) => {
  return (!_unref(isMinLarge))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.selectedView !== 'summary')
          ? (_openBlock(), _createBlock(_unref(IonSegment), {
              key: 0,
              value: __props.selectedView,
              scrollable: "true",
              mode: "md",
              class: "w-screen lg:w-auto",
              onIonChange: _cache[0] || (_cache[0] = e => changeRoute(e))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab, index) => {
                  return (_openBlock(), _createBlock(_unref(IonSegmentButton), {
                    key: index,
                    value: tab.identifier,
                    class: _normalizeClass([
          __props.selectedView === tab.identifier || (!__props.selectedView && index === 0) ? 'active' : '',
          tab.isUnlocked() ? '' : 'disabled'
        ]),
                    layout: "icon-start",
                    "data-cy": `btn-mobile-nav-${tab.identifier}`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ProgressIndicator), {
                        progress: tab.getProgress()
                      }, null, 8, ["progress"]),
                      _createVNode(_unref(IonLabel), { class: "normal-case" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tab.getTitle()), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["value", "class", "data-cy"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "w-screen lg:w-auto mt-2",
        "on:ionChange": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('change', $event)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["segment-button", [
        __props.selectedView === tab.identifier || (!__props.selectedView && index === 0) ? 'active' : '', tab.isUnlocked() ? '' : 'disabled'
      ]]),
            "data-cy": `btn-desktop-nav-${tab.identifier}`,
            layout: "icon-start",
            onClick: ($event: any) => (changeRouteDesktop(tab))
          }, [
            _createVNode(_unref(ProgressIndicator), {
              progress: tab.getProgress(),
              style: {"margin-right":"8px"},
              "data-cy": "progress-desktop"
            }, null, 8, ["progress"]),
            _createVNode(_unref(IonLabel), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(tab.getTitle()), 1)
              ]),
              _: 2
            }, 1024)
          ], 10, _hoisted_2))
        }), 128)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(AButton), {
            type: "button",
            fill: "solid",
            shape: "round",
            class: "mr-2",
            "data-cy": "btn-preview",
            "btn-primary": true,
            onClick: goToSummary
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("hzba.buttons.vorschau")), 1)
            ]),
            _: 1
          }),
          (ba.value?.hasPdfSupport())
            ? (_openBlock(), _createBlock(_unref(AButton), {
                key: 0,
                type: "button",
                fill: "solid",
                shape: "round",
                class: "mr-2",
                "data-cy": "btn-pdf-preview",
                "btn-primary": true,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.replace(`/ba/${ba.value?.id}/pdf-preview`)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("hzba.buttons.pdfVorschau")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(AButton), {
            type: "button",
            class: "action-button download-button h-12 w-12",
            fill: "solid",
            shape: "round",
            "data-cy": "btn-map",
            "btn-primary": true,
            onClick: downloadGeodata
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                icon: _unref(arrowDownCircleOutline),
                class: "w-6 h-6"
              }, null, 8, ["icon"])
            ]),
            _: 1
          }),
          (__props.showMapButton)
            ? (_openBlock(), _createBlock(_unref(AButton), {
                key: 1,
                type: "button",
                class: "action-button map-button h-12 w-12",
                fill: "solid",
                shape: "round",
                "data-cy": "btn-map",
                "btn-primary": true,
                onClick: showMap
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(mapOutline),
                    class: "w-6 h-6"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ], 32))
}
}

})